<template>
    <div>
        <tabs class="tabs"
            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-4 pt-0"
            tabContentClasses=""
        >
            <tab-pane id="objectives">
                <span slot="title">{{ $t('common.new') }}</span>
                <slot name="new" class="pt-3"></slot>
            </tab-pane>

            <tab-pane id="control">
                <span slot="title">{{ $t('common.existing') }}</span>
                <slot name="existing"></slot>
            </tab-pane>

        </tabs>
    </div>
</template>

<script>
    export default {
    }
</script>
